import {styled} from '@material-ui/core'

export const Container = styled('div')({
  maxHeight: '100vh',
  maxWidth: '100%',
  minHeight: 0,
  minWidth: 0,
  width: '100%',
})
